import { Directive, ElementRef, Renderer2, ViewContainerRef, Input, OnInit } from '@angular/core';
import {ComponentLoaderFactory} from 'ngx-bootstrap/component-loader';
import {TooltipConfig, TooltipDirective} from 'ngx-bootstrap/tooltip';
import {PositioningService} from 'ngx-bootstrap/positioning';


@Directive({
    selector: '[appEllipsisTooltip]'
})
export class EllipsisTooltipDirective extends TooltipDirective implements OnInit {

    @Input() appEllipsisTooltip: string;
    @Input() showTooltip: boolean;
    @Input() maxLength;
    originalText: string;
    isExceededMaximumLength = false;

    constructor(
        viewContainerRef: ViewContainerRef,
        cis: ComponentLoaderFactory,
        config: TooltipConfig,
        private eleRef: ElementRef,
        renderer: Renderer2,
        positionService: PositioningService
    ) {
        super(
            viewContainerRef,
            cis,
            config,
            eleRef,
            renderer,
            positionService
        );
        renderer.addClass(eleRef.nativeElement, 'ellipsis');
    }

    ngOnInit(): void {
        super.ngOnInit();
        let text = this.eleRef.nativeElement.textContent;
        if (this.maxLength > 0 && text.length > this.maxLength) {
            this.originalText = text;
            this.tooltip = text;
            text = text.substr(0, this.maxLength);
            text += '...';
            this.eleRef.nativeElement.innerText = text;
            this.isExceededMaximumLength = true;
        }
    }

    show(): void {
        if (this.showTooltip) {
            this.tooltip = this.appEllipsisTooltip;
            super.show();
            return;
        }
        if (this.isExceededMaximumLength) {
            this.tooltip = this.originalText;
            super.show();
            return;
        }
        this.tooltip = this.isEllipsisActive(this.eleRef.nativeElement) ? this.eleRef.nativeElement.innerText : '';
        super.show();
    }

    private isEllipsisActive(element: HTMLElement): boolean {
        return (element.offsetWidth < element.scrollWidth);
    }
}
